import { Card, Field } from '../../../components/ui';
import { POSITION_LABEL, SHAPE_LABEL, type CardProps } from './defaults';
import type { BannerAppearance } from '../../../lib/api';

type Layout = BannerAppearance['layout'];

export default function LayoutCard({ a, update, readOnly }: CardProps) {
  const l = a.layout;
  const set = (patch: Partial<Layout>) => update((x) => ({ ...x, layout: { ...x.layout, ...patch } }));
  const wall = l.shape === 'wall';
  // The Modal wall design dims the page on its own, so holding the page is allowed there too.
  const canHold = wall || a.template?.base === 'wall';

  return (
    <Card title="Layout">
      <div className="row">
        <Field label="Shape">
          <select value={l.shape} disabled={readOnly} onChange={(e) => {
            const shape = e.target.value as Layout['shape'];
            set(shape === 'wall' || a.template?.base === 'wall' ? { shape } : { shape, holdPage: false });
          }}>
            {(Object.keys(SHAPE_LABEL) as Layout['shape'][]).map((k) => <option key={k} value={k}>{SHAPE_LABEL[k]}</option>)}
          </select>
        </Field>
        <Field label="Position">
          <select value={wall ? 'bottom' : l.position} disabled={readOnly || wall} onChange={(e) => set({ position: e.target.value as Layout['position'] })}>
            {wall
              ? <option value="bottom">Centre, page dimmed</option>
              : (Object.keys(POSITION_LABEL) as Layout['position'][]).map((k) => <option key={k} value={k}>{POSITION_LABEL[k]}</option>)}
          </select>
        </Field>
      </div>
      <div className="check-list">
        <label className="ck-check">
          <input type="checkbox" checked={l.rail} disabled={readOnly} onChange={(e) => set({ rail: e.target.checked })} />
          Rail with accessibility and language controls
        </label>
        <label className="ck-check">
          <input type="checkbox" checked={l.languageControl} disabled={readOnly || !l.rail} onChange={(e) => set({ languageControl: e.target.checked })} />
          Language control
        </label>
        <label className="ck-check">
          <input type="checkbox" checked={l.holdPage} disabled={readOnly || !canHold} onChange={(e) => set({ holdPage: e.target.checked })} />
          Hold the page until a choice is made
        </label>
      </div>
      <div className="help" style={{ marginTop: 6 }}>
        Wall only: page content inert until a choice is made. The law asks for no non-essential cookie before consent, not for a held page.
      </div>
    </Card>
  );
}
